import React, { memo } from "react";

import { Box, Input } from "@chakra-ui/react";
import { ReactComponent as SearchIcon } from "assets/icons/table-search-icon.svg";

import { ITableSearchInputProps } from "./types";

export const TableSearchInput = memo((props: ITableSearchInputProps) => {
  const { searchQuery, handleSearchQueryChange, className, placeholder } =
    props;

  return (
    <Box className="w-[348px] h-9 rounded-lg border-[1px] border-[#EEEEF1] py-2 px-3 flex items-center gap-2">
      <Box className="w-4 h-4 flex-shrink-0">
        <SearchIcon className="w-full h-full" />
      </Box>
      <Input
        placeholder={placeholder || "Search here..."}
        className={`text-[#374151] bg-transparent w-[300px] h-[20px] placeholder:text-[#9C9BAB] focus:outline-none ${className} flex-shrink-0 text-sm`}
        onChange={handleSearchQueryChange}
        value={searchQuery}
      />
    </Box>
  );
});
